import {
  AUTH_LOGIN,
  AUTH_LOGIN_SUCCESS,
  AUTH_LOGIN_FAIL,
  FORGOT_PASSWORD,
  FORGOT_PASSWORD_SUCCESS,
  FORGOT_PASSWORD_FAIL,
  AUTH_LOGOUT,
} from "./types";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { getErrorMessage } from "../utils/utilFunctions";
import ApiInterfaceForPublicRoute from "utils/ApiInterfaceForPublicRoute";
import ApiInterface from "utils/ApiInterface";

export const login = (data, history) => (dispatch) => {
  dispatch({ type: AUTH_LOGIN });

  ApiInterfaceForPublicRoute.instance
    .login(data)
    .then((response) => {
      localStorage.setItem("isLoggedIn", "true");
      localStorage.setItem("email", data.email);
      localStorage.setItem("access_token", response.data.access_token);

      ApiInterfaceForPublicRoute.reInstance();

      dispatch({
        type: AUTH_LOGIN_SUCCESS,
        payload: response.data,
      });
      history.push("/");
    })
    .catch((error) => {
      dispatch({
        type: AUTH_LOGIN_FAIL,
        payload: error?.response?.data?.messages,
      });
      withReactContent(Swal).fire({
        title: "Error",
        html:
          error?.response?.data?.message ??
          error?.response.data.non_field_errors[0],
      });
    });
};

export const register = (data, history) => (dispatch) => {
  dispatch({ type: AUTH_LOGIN });

  ApiInterfaceForPublicRoute.instance
    .register(data)
    .then((response) => {
      // dispatch({type: AUTH_LOGIN_FAIL, payload: error?.response?.data?.messages});
      history.push("/email/verify");
      // localStorage.setItem('isLoggedIn', 'true');
      // localStorage.setItem('email', data.email);
      // localStorage.setItem('access_token', response.data.access_token);
      // ApiInterface.reInstance();
      //
      // dispatch({
      //   type: AUTH_LOGIN_SUCCESS,
      //   payload: response.data,
      // });
      // // history.push('/email/verify');
      // history.push('/map');
    })
    .catch((error) => {
      dispatch({
        type: AUTH_LOGIN_FAIL,
        payload: error?.response?.data?.messages,
      });
      withReactContent(Swal).fire({
        title: "Error",
        html: error?.response?.data?.message ?? error.response.data["email"][0],
      });
    });
};

export const resetPassword = (data, history) => (dispatch) => {
  dispatch({ type: FORGOT_PASSWORD });
  ApiInterface.instance
    .sendResetLinkEmail(data)
    .then((response) => {
      dispatch({
        type: FORGOT_PASSWORD_SUCCESS,
        payload: response.data.success,
      });
      // history.push('/ForgotPassword');
    })
    .catch((error) => {
      dispatch({
        type: FORGOT_PASSWORD_FAIL,
        payload: getErrorMessage(error.response),
      });
      // withReactContent(Swal).fire({
      //     title: 'Error',
      //     html: getErrorMessage(error.response),
      // });
    });
};

export const forgetPassword = (data, history) => (dispatch) => {
  dispatch({ type: FORGOT_PASSWORD });
  ApiInterface.instance
    .resetPassword(data)
    .then((response) => {
      dispatch({
        type: FORGOT_PASSWORD_SUCCESS,
        payload: response.data.detail,
      });
      history.push("/login");
    })
    .catch((error) => {
      dispatch({
        type: FORGOT_PASSWORD_FAIL,
        payload: error?.response?.data?.messages,
      });
      /*console.log(error.response, data);
    
     withReactContent(Swal).fire({
       title: "Error",
       html:
         error?.response?.data?.message ?? error?.response?.data?.messages[0],
     });*/
      alert(error.response.data);
      history.push("/login");
    });
};

export const loginGoogle = (data, history) => (dispatch) => {
  dispatch({ type: AUTH_LOGIN });

  ApiInterfaceForPublicRoute.instance
    .loginGoogle(data)
    .then((response) => {
      localStorage.setItem("isLoggedIn", "true");
      localStorage.setItem("email", data.email);
      localStorage.setItem("access_token", response.data.key);
      ApiInterface.reInstance();

      dispatch({
        type: AUTH_LOGIN_SUCCESS,
        payload: response.data,
      });
      history.push("/");
    })
    .catch((error) => {
      dispatch({
        type: AUTH_LOGIN_FAIL,
        payload: error?.response?.data?.messages,
      });
      withReactContent(Swal).fire({
        title: "Error",
        html: error?.response?.data?.message,
      });
    });
};

export const loginApple = (data, history) => (dispatch) => {
  dispatch({ type: AUTH_LOGIN });

  ApiInterfaceForPublicRoute.instance
    .loginApple(data)
    .then((response) => {
      localStorage.setItem("isLoggedIn", "true");
      localStorage.setItem("email", data.email);
      localStorage.setItem("access_token", response.data.access_token);
      ApiInterface.reInstance();

      dispatch({
        type: AUTH_LOGIN_SUCCESS,
        payload: response.data,
      });
      history.push("/map");
    })
    .catch((error) => {
      dispatch({
        type: AUTH_LOGIN_FAIL,
        payload: error?.response?.data?.messages,
      });
      withReactContent(Swal).fire({
        title: "Error",
        html:
          error?.response?.data?.message ?? error?.response?.data?.messages[0],
      });
    });
};

export const verifyEmail = (link, history) => (dispatch) => {
  dispatch({ type: AUTH_LOGIN });

  ApiInterface.instance
    .verifyEmail(link)
    .then((response) => {
      dispatch({
        type: AUTH_LOGIN_SUCCESS,
        payload: response.data,
      });
      history.push("/");
    })
    .catch((error) => {
      dispatch({
        type: AUTH_LOGIN_FAIL,
        payload: error?.response?.data?.messages,
      });
      withReactContent(Swal).fire({
        title: "Error",
        html:
          error?.response?.data?.message ?? error?.response?.data?.messages[0],
      });
    });
};

export const resendVerificationEmail = () => (dispatch) => {
  ApiInterface.instance
    .resendVerificationEmail()
    .then((response) => {
      withReactContent(Swal).fire({
        title: "Success",
        html: response?.data?.message,
      });
    })
    .catch((error) => {
      withReactContent(Swal).fire({
        title: "Error",
        html:
          error?.response?.data?.message ?? error?.response?.data?.messages[0],
      });
    });
};

export const logout = (history) => (dispatch) => {
  localStorage.clear();
  localStorage.setItem("isLoggedIn", "false");
  ApiInterface.reInstance();

  dispatch({ type: AUTH_LOGOUT });
  history.push("/login");
};
